import { withNamespaces } from 'react-i18next';

import {
    getMailboxIntentItem,
    getMailboxLinkedCaseId,
} from '../../../helpers';
import { displayedCaseReference } from 'src/helpers/case_reference_helper';

const MessageLinkedCases = ({
    t,
    cases = [],
}) => {
    if (!cases.length) {
        return null;
    }

    return (
        <div className="mailbox-message-detail__badges mailbox-message-row__pills">
            {cases.map((linkedCase) => {
                const intentItem = getMailboxIntentItem(linkedCase.intent);
                const caseId = getMailboxLinkedCaseId(linkedCase);

                if (!intentItem) {
                    return null;
                }

                return (
                    <span
                        key={`${linkedCase.intent}-${caseId}`}
                        className={`mailbox-message-row__pill ${intentItem.pillClass}`}
                    >
                        {t(intentItem.pillTitle)}: {displayedCaseReference(linkedCase)}
                    </span>
                );
            })}
        </div>
    );
};

export default withNamespaces()(MessageLinkedCases);
